/* jshint ignore: start */
// jscs:disable

(function($) {

    $.fn.FloatingTerms = function(options) {

        var self = this;
        var plugin = self;
        var $element = this;
        var screenWidth = $element.width();
        var screenHeight = $element.height();

        $element.data('FloatingTerms', plugin);

        var settings = $.extend({
            data: []
        }, options );

        plugin.init = function() {

            var i;
            var j;
            var tags = {};
            for (i = 0; i < settings.data.length; i++){
                for (j = 0; j < settings.data[ i ].tags.length; j++){
                    tags[ settings.data[ i ].tags[ j ] ] = true;
                }
            }

            var $termsGroup = $element.find('.scatter-post__terms');

            var keys = Object.keys(tags);
            var domString = "";
            for (i = 0; i < keys.length; i++){
                domString += "<div data-terms='"+ keys[ i ] +"' class='term hide-terms'>"+ keys[ i ] +"</div>";
            }
            $termsGroup.empty();
            $termsGroup.prepend(domString);
            plugin.terms = $termsGroup.find('.term');

            for (i = 0; i < plugin.terms.length; i++){
                var data_start_top = Math.random() * screenHeight;
                var data_start_left = Math.random() * screenWidth;
                $(plugin.terms[ i ]).css({
                    'top': data_start_top,
                    'left': data_start_left
                });
                $(plugin.terms[ i ]).attr('data-start-top', data_start_top);
                $(plugin.terms[ i ]).attr('data-start-left', data_start_left);
            }

            for (i = 0; i < plugin.terms.length; i++){
                plugin.moveTerm(plugin.terms[ i ]);
            }

            plugin.terms.on('mouseenter', plugin.haltTerm);
            plugin.terms.on('mouseleave', plugin.unhaltTerm);
            plugin.terms.on('click', function() {
                $element.trigger('TAG_CLICKED', this);
            });
        },

        plugin.haltTerm = function(_event){
            $(_event.currentTarget).attr('data-float', false);
            TweenMax.killTweensOf(_event.currentTarget);
            TweenMax.to(_event.currentTarget, 0, { alpha: 1, overwrite:"all" });
        },

        plugin.unhaltTerm = function(_event){
            $(_event.currentTarget).attr('data-float', true);
            plugin.moveTerm(_event.currentTarget);
        },

        plugin.moveTerm = function(_term){
            if ($(_term).attr('data-float') === false){
                return;
            }

            var onMoveComplete = function(term) {
                $(term).addClass('hide-terms');
            }

            var poolRadius = Math.random() * 30 + 2;
            var angle = Math.random() * Math.PI * 2;
            var radius = Math.random() * poolRadius;
            var xCenter = $(_term).attr('data-start-left');
            var yCenter = $(_term).attr('data-start-top');
            TweenMax.to(_term, Math.random() * 2 + 2, {alpha: 0, x:Math.cos(angle) * radius + xCenter, y:Math.sin(angle) * radius + yCenter, ease:Sine.easeInOut, onCompleteParams: [ _term ],  onComplete: onMoveComplete, overwrite:"all"});
        },

        plugin.unswarm = function(_event){
            var i;
            for (i = 0; i < plugin.terms.length; i++){
                $(plugin.terms[i]).attr('data-float', false);
                $(plugin.terms[i]).css({'pointer-events': 'auto'});
                plugin.moveTerm(plugin.terms[i]);
            }
        },

        plugin.swarm = function(_event){
            var $currentTarget = $(_event.currentTarget).parent();
            var i;
            var j;
            var showingTerms = [];
            var term;

            var hideTerm = function(term) {
                term.addClass('hide-terms');
            }

            $element.removeClass('hide-terms');

            for (i = 0; i < plugin.terms.length; i++){
                term = $(plugin.terms[ i ]);

                var currentTargetTerms = $currentTarget.attr('data-terms').split(',');
                var hit = false;

                for (j = 0; j < currentTargetTerms.length; j++){
                    if (term.attr('data-terms') === currentTargetTerms[ j ]){
                        hit = true;
                    }
                }

                if (hit === true){

                    showingTerms.push(plugin.terms[ i ]);

                    term.attr('data-float', false);
                    term.removeClass('hide-terms');
                }
            }

            var numberOfPoints = showingTerms.length;
            var angleIncrement = 360 / numberOfPoints;
            var circleRadius = Math.max($currentTarget.width(), $currentTarget.height());
            var random;
            var showingTerm;

            var rect = {
                x: parseInt($currentTarget.css('left'), 10),
                y: parseInt($currentTarget.css('top'), 10),
                width: $currentTarget.width(),
                height: $currentTarget.height()
            };

            var startingNumber = Math.random() * 100;

            for (i = 0; i < numberOfPoints; i++) {
                startingNumber = startingNumber + 1;
                showingTerm = $(showingTerms[ i ]);
                showingTerm.css({'pointer-events': 'none'});

                var p = {};
                p.x = rect.x + (rect.width / 2) + (circleRadius * Math.cos((angleIncrement * i) * (Math.PI / 180)));
                p.y = rect.y + (rect.height / 2) + (circleRadius * Math.sin((angleIncrement * i) * (Math.PI / 180)));

                p.x -= showingTerm.width() / 2;
                p.y -= showingTerm.height() / 2;

                TweenMax.killTweensOf(showingTerm);

                TweenMax.to(showingTerm, Math.random(), { alpha: 0, onCompleteParams: [showingTerm, p, rect], onComplete: plugin.swarmStart, overwrite:"all" });
            }
        },

        plugin.swarmStart  = function(showingTerm, p, rect){
            //TweenMax.to(showingTerm, 0, { top: p.y, left: p.x });

            var moved = false;
            var TAG_SPACING = 80;
            var ease = Expo.easeOut;
            var onComplete = function() {
                showingTerm.css({'pointer-events': 'auto'});
            }

            random = Math.random() + 0.9;

            // right
            if (p.x > rect.x + rect.width && p.y > rect.y && p.y < rect.y + rect.height){
                moved = 1;
            }

            // left
            if (p.x < rect.x && p.y > rect.y && p.y < rect.y + rect.height){
                moved = 2;
            }

            // top
            if (p.y < rect.y && p.x > rect.x && p.x < rect.x + rect.width){
                moved = 3;
            }

            // bottom
            if (p.y > rect.y + rect.height && p.x > rect.x && p.x < rect.x + rect.width){
                moved = 4;
            }

            if (!moved) {
                moved = Math.floor(Math.random() * 4) + 1;
            }

            switch (moved) {
                case 1:
                    TweenMax.to(showingTerm, random, { alpha: 0.5, top: p.y + (Math.random() * TAG_SPACING) - (Math.random() * TAG_SPACING), left: rect.x + rect.width, ease: ease, onComplete: onComplete});
                    break;
                case 2:
                    TweenMax.to(showingTerm, random, { alpha: 0.5, top: p.y + (Math.random() * TAG_SPACING) - (Math.random() * TAG_SPACING), left: rect.x - showingTerm.width(), ease: ease, onComplete: onComplete });
                    break;
                case 3:
                    TweenMax.to(showingTerm, random, {
                        alpha: 0.5,
                        left: p.x + (Math.random() * TAG_SPACING) - (Math.random() * TAG_SPACING),
                        top: rect.y - showingTerm.height(), ease: ease, onComplete: onComplete
                    });
                    break;
                default:
                case 4:
                    TweenMax.to(showingTerm, random, {
                        alpha: 0.5,
                        left: p.x + (Math.random() * TAG_SPACING) - (Math.random() * TAG_SPACING),
                        top: rect.y + rect.height, ease: ease, onComplete: onComplete
                    });
            }
        },

        plugin.init();

        return plugin;
    };
})(jQuery);

/* jshint ignore: end */
// jscs:enable
